module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "profile-clinic layout__box"
  }, [_c('div', {
    staticClass: "basic-box"
  }, [(_vm.roomId !== _vm.id) ? _c('router-link', {
    staticClass: "basic-link-box",
    attrs: {
      "to": {
        name: 'Personal'
      }
    }
  }, [_c('i', {
    staticClass: "icon ion-arrow-left-c profile__arrow-icon"
  }), _vm._v(" "), _c('a', {
    staticClass: "basic-link profile__basic-link bold"
  }, [_vm._v("Вернуться к списку сотрудников")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "basic-box__row-wrap"
  }, [_c('div', {
    staticClass: "basic-box__row hr"
  }, [_c('div', {
    staticClass: "basic-box__row-inner"
  }, [_c('div', {
    staticClass: "basic-box__row-item basic-box__row-item_avatar-wrap"
  }, [_c('user-avatar', {
    attrs: {
      "data": _vm.workerModel.user,
      "setClass": 'basic-box__avatar'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "basic-box__row-item basic-box__row-item_name profile__row-item_mr"
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.workerModel.user_last_name) + " " + _vm._s(_vm.workerModel.user_first_name) + " " + _vm._s(_vm.workerModel.user_middle_name) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "basic-box__text basic-box__text_size"
  }, [_vm._v(_vm._s(_vm.workerModel.position))])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "basic-box profile-clinic__basic-box"
  }, [_c('div', {
    staticClass: "basic-box__inner basic-box__inner_pad profile-clinic__inner flex"
  }, [_c('div', {
    staticClass: "basic-box__title basic-box__title_margin"
  }, [_vm._v("Ведет прием")]), _vm._v(" "), _c('div', {
    staticClass: "basic-box__btns basic-box__btns_placing"
  }, [_c('button', {
    staticClass: "basic-box__btn basic-blue-btn profile-clinic__btn",
    class: {
      'profile-clinic__btn_active': _vm.workerModel.can === 'yes'
    },
    on: {
      "click": function($event) {
        _vm.setCan('yes')
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\tСвободная запись\n\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "basic-box__btn basic-blue-btn profile-clinic__btn",
    class: {
      'profile-clinic__btn_active': _vm.workerModel.can === 'by_request'
    },
    on: {
      "click": function($event) {
        _vm.setCan('by_request')
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\tЗапись по заявкам\n\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "basic-box__btn basic-blue-btn profile-clinic__btn",
    class: {
      'profile-clinic__btn_active': _vm.workerModel.can === 'no'
    },
    on: {
      "click": function($event) {
        _vm.setCan('no')
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\tНе ведется прием\n\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "basic-box__inner basic-box__inner_pad flex profile-clinic__inner"
  }, [_c('div', {
    staticClass: "basic-box__title basic-box__title_margin"
  }, [_vm._v("Длительность приема, мин")]), _vm._v(" "), _c('div', {
    staticClass: "timer flex profile__timer"
  }, [_c('div', {
    staticClass: "timer__minus-btn",
    on: {
      "click": _vm.decreaseTime
    }
  }, [_c('i', {
    staticClass: "timer__icon icon ion-minus-round"
  })]), _vm._v(" "), _c('div', {
    staticClass: "timer__time-value"
  }, [_vm._v(_vm._s(_vm.workerModel.time))]), _vm._v(" "), _c('div', {
    staticClass: "timer__plus-btn",
    on: {
      "click": _vm.increaseTime
    }
  }, [_c('i', {
    staticClass: "timer__icon icon ion-plus-round"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "basic-box profile-clinic__basic-box flex"
  }, [_c('schedule-editor', {
    attrs: {
      "schedule": _vm.workerModel.schedule
    }
  }), _vm._v(" "), _c('vacation-editor', {
    attrs: {
      "holidays": _vm.specialHolidays
    }
  }), _vm._v(" "), _c('div')], 1), _vm._v(" "), _c('div', {
    staticClass: "basic-box profile-clinic__basic-box"
  }, [_c('div', {
    staticClass: "basic-box__inner basic-box__inner_pad flex"
  }, [_c('div', {
    staticClass: "basic-box__title basic-box__title_margin"
  }, [_vm._v("Роль в клинике")]), _vm._v(" "), _c('div', {
    staticClass: "basic-box__select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.role),
      expression: "role"
    }],
    staticClass: "select select_role",
    attrs: {
      "title": "title",
      "disabled": !_vm.Role.isAdmin
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.role = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.roles), function(role) {
    return _c('option', {
      domProps: {
        "value": role._id
      }
    }, [_vm._v(_vm._s(role.name))])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "basic-box__inner basic-box__inner_pad flex"
  }, [_c('div', {
    staticClass: "basic-box__title basic-box__title_margin"
  }, [_vm._v("Должность")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.workerModel.position),
      expression: "workerModel.position"
    }],
    staticClass: "basic-box__text-field",
    attrs: {
      "placeholder": "Название должности",
      "type": "text",
      "disabled": !_vm.Role.isAdmin
    },
    domProps: {
      "value": (_vm.workerModel.position)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.workerModel, "position", $event.target.value)
      }
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14d53826"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Cabinet/Clinic/Tabs/Profile.vue
// module id = 587
// module chunks = 0